import { render, staticRenderFns } from "./trainCourseApply.vue?vue&type=template&id=c6e6bbce&scoped=true&"
import script from "./trainCourseApply.vue?vue&type=script&lang=js&"
export * from "./trainCourseApply.vue?vue&type=script&lang=js&"
import style0 from "./trainCourseApply.vue?vue&type=style&index=0&id=c6e6bbce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e6bbce",
  null
  
)

export default component.exports